import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    height: 'calc(100% - 64.5px - 1.75rem)',

    // Other breakpoints shift here
    [theme.breakpoints.down(807)]: {
      height: 'calc(100% - 64.5px - 4.75rem)'
    },

    // Agent page adds bottom nav here
    [theme.breakpoints.down(593)]: {
      height: 'calc(100% - 64.5px - 7rem)'
    }
  }
}))

export default useStyles
